<template>
  <div class="decks">
    <search />
  </div>
</template>

<script>
import Search from '../../shared/Search'
export default {
  components: {
    Search
  }
}
</script>

<style lang="scss" scoped>

</style>
